<div class="container my-3">
  <div class="d-flex gap-2 mb-3">
    <button class="btn btn-outline-secondary" (click)="goBack()">
      <fa-icon [icon]="faCircleArrowLeft"></fa-icon>
      Back
    </button>
    <button class="btn btn-outline-primary" (click)="goHome()">
      <fa-icon [icon]="faHomeAlt"></fa-icon>
      Home
    </button>
  </div>

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h3 class="mb-1">Manage License</h3>
      @if (selectedProperty) { <p class="text-muted mb-0">Property: {{ selectedProperty.name }}</p> }
    </div>
    @if (canManageSubscriptions) {
      <button type="button" class="btn btn-primary" (click)="onAddSubscription()">Add <fa-icon [icon]="faPlusCircle"></fa-icon></button>
    }
  </div>

  @if (loading) {
    <div class="alert alert-info">Loading subscription...</div>
  }

  @if (!loading && errorMessage) {
    <div class="alert alert-danger">{{ errorMessage }}</div>
  }

  @if (!loading && !errorMessage && subscriptions.length) {
    <div class="table-responsive">
      <table class="table table-striped align-middle">
        <thead><tr><th>Contact</th><th>Description</th><th>Period</th><th>Payment</th><th>Status</th>@if (canManageSubscriptions) { <th></th> }</tr></thead>
        <tbody>
          @for (subscription of subscriptions; track subscription.id) {
            <tr>
              <td>{{ subscription.mainContactName }}<br><small>{{ subscription.email }}</small></td>
              <td>{{ subscription.shortDescription }}</td>
              <td>{{ subscription.startDate | date:'mediumDate' }} - {{ subscription.endDate | date:'mediumDate' }}</td>
              <td>{{ subscription.paymentAmount | currency }} {{ subscription.paymentFrequency }}</td>
              <td>{{ subscription.active ? 'Active' : 'Inactive' }}</td>
              @if (canManageSubscriptions) {
                <td class="text-nowrap">
                  <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="onEditSubscription(subscription)"><fa-icon [icon]="faPenToSquare"></fa-icon></button>
                  <button type="button" class="btn btn-sm btn-outline-danger" (click)="onDeleteSubscription(subscription)"><fa-icon [icon]="faTimesCircle"></fa-icon></button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (!loading && !errorMessage && !subscriptions.length && !!selectedProperty) {
    <div class="alert alert-warning">No subscription found for this property.</div>
  }

  @if (canManageSubscriptions && (creatingSubscription || editingSubscriptionId !== null || subscriptions.length === 0)) {
    <form class="border-top pt-3 mt-4" [formGroup]="subscriptionForm" (ngSubmit)="onSaveSubscription()">
      <h4>{{ editingSubscriptionId ? 'Edit Subscription' : 'Add Subscription' }}</h4>
      <div class="row g-3">
        <div class="col-md-6"><label class="form-label">Contact name</label><input class="form-control" formControlName="mainContactName"></div>
        <div class="col-md-6"><label class="form-label">Email</label><input class="form-control" type="email" formControlName="email"></div>
        <div class="col-md-6"><label class="form-label">Company</label><input class="form-control" formControlName="companyName"></div>
        <div class="col-md-6"><label class="form-label">Description</label><input class="form-control" formControlName="shortDescription"></div>
        <div class="col-md-6"><label class="form-label">Start date</label><input class="form-control" type="date" formControlName="startDate"></div>
        <div class="col-md-6"><label class="form-label">End date</label><input class="form-control" type="date" formControlName="endDate"></div>
        <div class="col-md-4"><label class="form-label">Amount</label><input class="form-control" type="number" min="0" formControlName="paymentAmount"></div>
        <div class="col-md-4"><label class="form-label">Frequency</label><input class="form-control" formControlName="paymentFrequency"></div>
        <div class="col-md-4"><label class="form-label">Unit number</label><input class="form-control" type="number" min="0" formControlName="unitNumber"></div>
        <div class="col-12"><label class="form-label">Long description</label><textarea class="form-control" rows="3" formControlName="longDescription"></textarea></div>
        <div class="col-12"><div class="form-check"><input class="form-check-input" type="checkbox" id="subscription-active" formControlName="active"><label class="form-check-label" for="subscription-active">Active</label></div></div>
      </div>
      <div class="mt-3 d-flex gap-2"><button class="btn btn-primary" type="submit" [disabled]="saving">Save</button><button class="btn btn-outline-secondary" type="button" (click)="onCancelEdit()">Cancel</button></div>
    </form>
  }
</div>
